import type { ReactNode } from "react";

interface Props {
  title: string;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
}

export function SectionHeader({ title, actionLabel, onAction, className = "" }: Props) {
  return (
    <div className={`flex items-center justify-between ${className}`}>
      <h2 className="text-xl font-bold text-ios-label">{title}</h2>
      {actionLabel && onAction && (
        <button onClick={onAction} className="text-sm font-semibold text-ios-primary">
          {actionLabel}
        </button>
      )}
    </div>
  );
}
